import * as React from "react";
import { Upload } from "../models/upload";
import { UploadItem } from "./UploadItem";
import { deleteResourceUpload } from "../services/fileUpload";

export const UploadList = (props: {
  uploads: Upload[];
  deleteUpload?: (uploadId: number) => void;
}) => {
  let { uploads, deleteUpload } = props;

  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>Filename</th>
            <th>Size</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {uploads.map(u => (
            <UploadItem
              key={u.id}
              upload={u}
              delete={
                deleteUpload !== undefined
                  ? () => deleteUpload && deleteUpload(u.id)
                  : undefined
              }
            />
          ))}
        </tbody>
      </table>
      {uploads.length == 0 ? <div>No uploads yet</div> : null}
    </div>
  );
};
